import { themeVars } from '@tundr/theme';
import { style } from '@vanilla-extract/css';

export const sidePanelActionsContainerClass = style({
  display: 'flex',
  width: '100%',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: themeVars.space.x4,
});
